import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useFormik } from 'formik';
import * as Yup from 'yup';
import authServices from '../../Services/authServices';

export const Register = () => {
    const [resError, setError] = useState('')

    const history = useHistory()
    const formik = useFormik({
        initialValues: {
            admin_email: '',
            admin_password: '',
            password: '',
            admin_name: ''
        },
        validationSchema: Yup.object({
            admin_name: Yup.string()
                .min(2, 'Must be 2 characters or more')
                .required('Required'),
            admin_password: Yup.string()
                // .matches('[a-zA-Z][a-zA-Z0-9]', 'enter')
                .min(6, 'Must be 6 characters or more')
                .required('Required').when("password", {
                    is: val => (val && val.length > 0 ? true : false),
                    then: Yup.string().oneOf(
                        [Yup.ref("password")],
                        "Password don't match"
                    )
                })
            ,
            password: Yup.string().min(6, 'Must be 6 characters or more').required('Required'),
            admin_email: Yup.string().email('Invalid email address').required('Required'),
        }),
        onSubmit: values => {
            let postData = {
                ...values,
                admin_email: values.admin_email.toLowerCase(),
                admin_type: 'SUPERADMIN'
            }
            authServices.registration(postData).then(res => {
                if (res.status) {
                    history.push('/login')
                } else {
                    setError(res.message)
                }
            })
        },
    });
    return (
        <div className="authentication-bg">
            <div className="account-pages pt-sm-5">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="text-center">
                                <a href="index.html" className="mb-5 d-block auth-logo">
                                    <img src="/admin/assets/images/logo_dark.svg" alt="" height={50} className="logo logo-dark" />
                                    <img src="/admin/assets/images/logo-light.png" alt="" height={22} className="logo logo-light" />
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className="row align-items-center justify-content-center">
                        <div className="col-md-8 col-lg-6 col-xl-5">
                            <div className="card">
                                <div className="card-body p-4">
                                    <div className="text-center mt-2">
                                        <h5 className="text-primary">Register Account</h5>
                                    </div>
                                    <div className="p-2 mt-4">
                                        <form onSubmit={formik.handleSubmit}>
                                            <div className="mb-3">
                                                <label className="form-label" >Email Address</label>
                                                <input
                                                    className={'form-control' + (formik.touched.admin_email ? !formik.errors.admin_email ? ' is-valid' : ' is-invalid' : '')}
                                                    type="email" {...formik.getFieldProps('admin_email')}
                                                    placeholder="Enter email"

                                                />
                                                {formik.touched.admin_email && formik.errors.admin_email ? (
                                                    <div className="text-danger">{formik.errors.admin_email}</div>
                                                ) : null}
                                            </div>
                                            <div className="mb-3">
                                                <label className="form-label" htmlFor="username">Username</label>
                                                <input
                                                    className={'form-control' + (formik.touched.admin_name ? !formik.errors.admin_name ? ' is-valid' : ' is-invalid' : '')}
                                                    type="text" {...formik.getFieldProps('admin_name')}
                                                    placeholder="Enter your name"
                                                />
                                                {formik.touched.admin_name && formik.errors.admin_name ? (
                                                    <div className="text-danger">{formik.errors.admin_name}</div>
                                                ) : null}
                                            </div>
                                            <div className="mb-3">
                                                <label className="form-label" htmlFor="password">Password</label>
                                                <input
                                                    className={'form-control' + (formik.touched.password ? !formik.errors.password ? ' is-valid' : ' is-invalid' : '')}
                                                    type="password" {...formik.getFieldProps('password')}
                                                    placeholder="Enter password"
                                                />
                                                {formik.touched.password && formik.errors.password ? (
                                                    <div className="text-danger">{formik.errors.password}</div>
                                                ) : null}
                                            </div>
                                            <div className="mb-3">
                                                <label className="form-label" htmlFor="userpassword">Confirm password</label>
                                                <input
                                                    className={'form-control' + (formik.touched.admin_password ? !formik.errors.admin_password ? ' is-valid' : ' is-invalid' : '')}
                                                    type="password" {...formik.getFieldProps('admin_password')}
                                                    placeholder="Enter password"
                                                />
                                                {formik.touched.admin_password && formik.errors.admin_password ? (
                                                    <div className="text-danger">{formik.errors.admin_password}</div>
                                                ) : null}
                                            </div>
                                            <div className="text-danger w-100 text-center mt-1">
                                                {resError}
                                            </div>
                                            <div className="mt-3 text-end">
                                                <button className="btn btn-primary w-sm waves-effect waves-light"
                                                    type="submit"
                                                >Register</button>
                                            </div>
                                            <div className="mt-4 text-center">
                                            </div>
                                            <div className="mt-4 text-center">
                                                <p className="text-muted mb-0">Already have an account ? <a onClick={() => history.push('/login')} className="fw-medium text-primary pointer"> Login</a></p>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                            <div className="mt-5 text-center">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
